<template>
    <div>
        <self-back :pageHeaderList="[{'name':'签约公司账户配置'}]"></self-back>
        <div class="content" v-loading='loading'>
            <div class="clear topBox">
                <div class="left">
                    <button class="addaccountButton" @click="addaccountEvent">+ 添加签约公司账户配置</button>
                </div>
                <el-input placeholder="请输入签约公司名称" v-model.trim="account_name" clearable  @keydown.enter.native="account_name?init(1):''" @clear="init(1)" size="mini" style="width:200px;margin-left:10px">
                    <el-button slot="append" icon="el-icon-search" @click="account_name?init(1):''" style="padding:0 10px"></el-button>
                </el-input>
            </div>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="customerList"
                :max-height="tableMaxHeight"
                border
                >
                <!-- <el-table-column prop="id" label="序列号" align='center'></el-table-column> -->
                <el-table-column prop="name" label="签约公司主体全称" align='center'></el-table-column>
                <el-table-column prop="bank" label="开户银行" align='center'></el-table-column>
                <el-table-column prop="account" label="银行账户" align='center'></el-table-column>
                <el-table-column
                align='center'
                width='160'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="updateEvent(scope.row)">修改</button>
                        <button style="background:#FC726D" v-if="scope.row.del_enable==1" @click="deleteaccountFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox" style="height: 30px;">
                <el-pagination
                    small
                    background
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-size="page_size"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 添加账号 -->
        <el-dialog
            :title="isEdit?'编辑签约公司账户配置':'添加签约公司账户配置'"
            :visible.sync="addaccountFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox" v-loading='loading'>
                <div class="dialogitem">
                    <label><em>*</em>签约公司主体全称:</label>
                    <el-select class="input" v-model="name" style="width:56%" size='mini' filterable placeholder="签约公司主体全称">
                        <el-option
                        v-for="(item,index) in signCompanyList"
                        :key="index"
                        :label="item.company"
                        :value="item.company">
                        </el-option>
                    </el-select>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>开户银行：</label>
                    <el-input
                        placeholder="请输入开户银行"
                        style="width:56%"
                        v-model.trim="bank"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>银行账户：</label>
                    <el-input
                        placeholder="请输入银行账户"
                        style="width:56%"
                        v-model.trim="account"
                        size='small'
                        clearable>
                    </el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
                <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addaccountFlag:false,
            deleteaccountFlag:false,
            customerList:[],
            page:1,
            page_size:20,
            total:0,
            loading:false,
            isEdit:false,
            customer_name:'',
            name:'',
            bank:'',
            account:'',
            signCompanyList:[],
            id:'',
            account_name:''
        }
    },
    computed: {
    // 计算表格最大高度，确保分页控件可见
    tableMaxHeight() {
      // Header(60) + self-back(50) + padding(30) + button(30) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 320px
      return window.innerHeight - 260;
    }
  },
    created(){
        var date = new Date();
        this.costCompanys()
        this.init(1)
    },
    methods:{
        updateEvent(data){
            this.addaccountFlag = true;
            this.isEdit = true;
            this.name = data.name
            this.bank = data.bank;
            this.account = data.account;
            this.id = data.id;
        },
        costCompanys(){
            this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList,{
                params:{
                    page:1,
                    pagesize:1000
                }
            }).then((res) => {
                var res=res.data;
                if(res&& res.errno == 0){
                    this.signCompanyList = res.rst.data;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
            })
        },
        addaccountEvent(){//点击添加账号按钮
            this.addaccountFlag = true;
            this.isEdit = false;
        },
        deleteaccountFlagEvent(data){//删除账号
            this.$confirm('确定要删除该配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.partyBAccountDestroy,{
                        id: data.id,
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.init(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {        
            });
        },
        handleCurrentChange(val){
            this.init(val)
        },
        init(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.partyBAccountList,{
               params:{
                   page: page,
                   pagesize: this.page_size,
                   name:this.account_name
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.customerList = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addaccountYes(){//添加账号
            if(this.name == ''){
                this.$message({
                    message: '请输入签约公司主体全称',
                    type: 'fail'
                })
                return
            }
            if(this.bank == ''){
                this.$message({
                    message: '请输入开户银行',
                    type: 'fail'
                })
                return
            }
            if(this.account == ''){
                this.$message({
                    message: '请输入银行账号',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                var params = {
                    name: this.name,
                    bank: this.bank,
                    account:this.account,
                    id:this.id
                }
            }else{
                var params = {
                    name: this.name,
                    bank: this.bank,
                    account:this.account,
                }
            }
            this.loading = true
            var axios_api = this.URL.partyBAccountStore
            if(this.isEdit){
                axios_api = this.URL.partyBAccountUpdate
            }
            this.$axios.post(this.URL.BASEURL + axios_api,params).then((res) => {
                var res=res.data;
                this.loading = false
                if(res&& res.errno == 0){
                    this.init(this.page)
                    this.cancelAddaccount()
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        cancelAddaccount(){//取消添加账号
            this.addaccountFlag = false;
            this.name = '';
            this.bank = '';
            this.account = '';
            this.isEdit = false;
            this.id = '';
        },
    },
    watch:{
    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 0;
    // display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .addaccountButton{
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        padding:0 10px;
    }
    .table{
        margin-top: 15px;
        button{
            min-width: 48px;
            height: 22px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 130px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
        em{
            color: red;
        }
    }
}
.topBox{
    .left{
        float: left;
    }
    .right{
        float: right;
        .lianjie{
            background: #5c7bfe;
            border: none;
            color: #ffffff;
            font-size: 12px;
            line-height: 30px;
            border-radius: 4px;
            padding: 0 8px;
            a{
                color: #FFFFFF;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/partyBAccount.vue